export default __webpack_public_path__ + "static/media/GetDemoImage.bf47616d.png";